module.exports = __webpack_public_path__ + "img/web_Winona_r1_03F_83231.d061abe1.svg";